// extracted by mini-css-extract-plugin
export var numpadContainer = "_km-1";
export var phoneButton = "_km-0";